<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p02">
<h1 class="part"><a id="page31"></a><img alt="" src="OEBPS/images/Wilc_9780312322496_epub_L02_r1.png"/> <em>PART TWO</em></h1>
<h1 class="subchapter">WAR</h1>
<div class="block">
<p class="nonindent">“You had to mature fast or die.<br/>I just sort of clenched down and lost<br/>feelings and went at it.”</p>
<p class="right">—<em>Butch Voris</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312322496_epub_p02_r1.vue?022f6113